"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addBaseUtilityTerm = void 0;
var obj_utils_1 = require("@harmoniclabs/obj-utils");
var punsafeConvertType_1 = require("../../punsafeConvertType/index.js");
var Term_1 = require("../../../Term/index.js");
function addBaseUtilityTerm(term) {
    if (!(0, obj_utils_1.hasOwn)(term, "as") ||
        typeof term.as !== "function" ||
        term.as === Term_1.Term.prototype.as) {
        (0, obj_utils_1.defineReadOnlyProperty)(term, "as", punsafeConvertType_1.term_as.bind(term));
    }
    return term;
}
exports.addBaseUtilityTerm = addBaseUtilityTerm;
